import React, { useEffect, useRef, useState } from 'react';
import { API } from '../../API';
import { CircularProgress } from '@mui/material';

const TeacherHours = ({ user }) => {
  const [hours, setHours] = useState("0:00");
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setIsLoading(true)
    API.getTotalHoursOfTeacher(user._id)
      .then((res) => {
        const totalHours = res?.data?.data?.totalHours
        const hours = parseInt(totalHours)
        const minutes = parseInt((parseFloat(totalHours) % 1) * 60)
        setHours(hours.toString() + ":" + handleShowMinutes(minutes));
      })
      .catch((err) => {
        console.log(`⚡️[log]: †††††† ~ err: `, err);
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [user]);

  const handleShowMinutes = (minutes) => {
    if (minutes >= 0 && minutes < 10) {
      return '0' + minutes;
    }

    return minutes
  }

  return (
    <div className="hours-card">
      {
        isLoading
        ? <CircularProgress className="loading"/> 
        : <>
          <div className="hours-number">
            <p className="hours">{hours}</p>
            <p className="hours-label">HRS</p>
          </div>
        </>
      }
    </div>
  );
};

export default TeacherHours;